// Global switches for the video screens.

// One global switch between the Wowza upload screen and the Bunny one. The old
// screen is never edited, so rolling back is an env change plus the single
// conditional import in VdoSetUnitEdit.vue.
export function isBunnyUpload() {
  return String(process.env.VUE_APP_VIDEO_PROVIDER || '').trim().toLowerCase() === 'bunny';
}

// Whether the "download this topic's video" controls render at all.
//
// Off by default, and off for BOTH providers, because neither can currently
// serve a downloadable file:
//
//   Bunny  -- a download needs a play_{h}p.mp4, which only exists when the
//             library's MP4 Fallback setting is on. It is off on libraries
//             722548 and 722542 and stays off: enabling it stores a second
//             copy of every video and the extra bill was not approved.
//             Verified 2026-08-17 -- Get Video reports hasMP4Fallback false
//             and hasOriginal false, and every play_*.mp4 404s at the CDN
//             while the HLS renditions serve fine.
//   Wowza  -- disabled alongside it so the two screens do not disagree about
//             whether the feature exists, which is what the users saw before.
//
// The handlers behind these controls are left in place. Re-enabling is this
// env variable, not a revert -- but for Bunny it also needs MP4 Fallback on
// and the affected videos re-encoded, since the setting only applies to
// encodes that run after it is turned on.
export function isVideoDownloadEnabled() {
  return String(process.env.VUE_APP_VIDEO_DOWNLOAD || '').trim().toLowerCase() === 'true';
}
